module.exports = __webpack_public_path__ + "img/handmirror.ea1d13fd.svg";